<script setup lang="ts">
import type { DynamicAuctionBanner } from '@autobid/strapi-integration/rest/components'
import BACKGROUND_COLORS_CLASSES from '@autobid/ui/constants/BACKGROUND_COLORS_CLASSES'

interface Props {
  fontColor: NonNullable<NonNullable<DynamicAuctionBanner['leftBackgroundColor']>['name']>
  opacity: DynamicAuctionBanner['backgroundColorOpacity']
}

defineProps<Props>()
</script>

<template>
  <div
    :class="BACKGROUND_COLORS_CLASSES[fontColor]"
    :style="{ opacity: `${opacity}%` }"
    class="absolute inset-0 z-[-1] hidden h-full w-full lg:block"
  />
</template>
